import { createAction, props } from '@ngrx/store';

import type { ChatConversation } from '@blaze-dashboard/ai-chat-domain';

export const loadLatestChatConversation = createAction(
  '[AI Chat] Load latest chat conversation',
  props<{ projectId: string }>(),
);

export const loadLatestChatConversationSuccess = createAction(
  '[AI Chat] Load latest conversation success',
  props<{ conversation: ChatConversation }>(),
);

export const loadLatestChatConversationFailure = createAction(
  '[AI Chat] Load latest conversation failure',
  props<{ projectId: string; error: string }>(),
);

export const createChatConversation = createAction(
  '[AI Chat] Create conversation',
  props<{ projectId: string }>(),
);

export const createChatConversationSuccess = createAction(
  '[AI Chat] Create conversation success',
  props<{ conversation: ChatConversation }>(),
);

export const createChatConversationFailure = createAction(
  '[AI Chat] Create conversation failure',
  props<{ projectId: string; error: string }>(),
);
